export interface Point {
  x: number
  y: number
}

// Pointer travel beyond this is a swipe or a text drag, not a click
const DRAG_TOLERANCE = 5

/**
 * Whether a click on a toast should open its shortcut. Error toasts, drags, selected text
 * and clicks on the toast's own buttons and links are left to their default behaviour.
 */
export const isToastClick = (
  toast: HTMLElement,
  event: MouseEvent,
  start: Point | undefined
): boolean => {
  if (toast.dataset.type === 'error') {
    return false
  }

  if (event.target instanceof Element && event.target.closest('button, a')) {
    return false
  }

  if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > DRAG_TOLERANCE) {
    return false
  }

  const selection = window.getSelection()

  if (selection && !selection.isCollapsed && toast.contains(selection.anchorNode)) {
    return false
  }

  return true
}
